import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-level-locked-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './level-locked-modal.component.html',
  styleUrls: ['./level-locked-modal.component.scss']
})
export class LevelLockedModalComponent {

  constructor(public activeModal: NgbActiveModal) {}

}
